<template>
	<div class="hook" ref="hook"></div>
</template>

<script>
	import Vue from 'vue'

	export default {
		name: 'hookAside',
		props: {
			componente: Object
		},
		mounted () {

			const ComponentClass = Vue.extend(this.componente)

			const instance = new ComponentClass()

			instance.$mount()

			this.$refs.hook.appendChild(instance.$el)

		}
	}
</script>
